<section class="sm:min-h-[24rem] min-h-[40rem] sm:max-h-[60vh] px-[2rem] py-[1rem] overflow-hidden sm:min-w-[48.2rem] sm:max-w-[30vw] flex flex-col bg-white" role="alertdialog" aria-modal="true" aria-labelledby="confirm-message">
  <mat-dialog-content class="!flex !flex-1 items-center justify-center text-center">
    <p id="confirm-message" class="!min-h-fit !m-0 dsr-typescale-body-medium text-center w-full">
      @if(data.isHtml) {
        <span [innerHTML]="safeMessage"></span>
      }
      @if(!data.isHtml) {
        <span>{{message}}</span>
      }
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="" role="group" aria-label="Confirmation actions">
    <button mat-flat-button class="" (click)="closeDialog(true)" type="button" aria-label="Confirm action">
      <span class="">{{'CONFIRM_BUTTON' | translate}}</span>
    </button>
    <button mat-stroked-button color="primary" (click)="closeDialog(false)" class="" type="button" aria-label="Cancel action">
      <span class="">{{'CANCEL_BUTTON' | translate}}</span>
    </button>
  </mat-dialog-actions>
</section>